import React from 'react';
import { useTranslation } from 'react-i18next';
import { TbCertificate, TbSchool } from 'react-icons/tb';
import '../i18n';
import { education } from '../data/profile';
import Reveal from './Reveal';
import './assets/css/education.css';

function Education() {
  const { t } = useTranslation();

  return (
    <section className="section section-alt" id="education">
      <div className="section-inner">
        <Reveal className="section-header">
          <span className="section-eyebrow">{t('edu_eyebrow')}</span>
          <h2 className="section-title">{t('edu_title')}</h2>
        </Reveal>

        <ul className="edu-grid">
          {education.map((edu, index) => {
            const isDegree = edu.type === 'type_degree';
            const Icon = isDegree ? TbSchool : TbCertificate;
            return (
              <Reveal
                as="li"
                key={edu.title}
                className={`edu-card ${isDegree ? 'degree' : ''}`}
                delay={(index % 2) * 0.08}
              >
                <span className="edu-icon" aria-hidden="true"><Icon /></span>
                <div className="edu-body">
                  <div className="edu-top">
                    <span className={`edu-type ${isDegree ? 'degree' : ''}`}>{t(edu.type)}</span>
                    <span className="edu-period">{edu.period}</span>
                  </div>
                  <h3 className="edu-title">{t(edu.title)}</h3>
                  <p className="edu-inst">{t(edu.institution)}</p>
                </div>
              </Reveal>
            );
          })}
        </ul>
      </div>
    </section>
  );
}

export default Education;
